const COLOR_CACHE_KEY = "avatar_color_cache";

const getCache = () => {
    try {
        return JSON.parse(localStorage.getItem(COLOR_CACHE_KEY)) || {};
    } catch {
        return {};
    }
};

const setCache = (cache) => {
    localStorage.setItem(COLOR_CACHE_KEY, JSON.stringify(cache));
};

const generateGradient = () => {
    const hue1 = Math.floor(Math.random() * 360);
    const hue2 = (hue1 + 40 + Math.random() * 40) % 360;

    return `linear-gradient(135deg, hsl(${hue1}, 65%, 45%), hsl(${hue2}, 65%, 55%))`;
};

export const getAvatarGradient = (key) => {
    if (!key) return generateGradient();

    const cache = getCache();

    if (cache[key]) {
        return cache[key];
    }

    const gradient = generateGradient();
    cache[key] = gradient;
    setCache(cache);

    return gradient;
};

export const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "?";

    if (words.length === 1) {
        return words[0][0].toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
};